var PlayerActions = /* @__PURE__ */ ((PlayerActions2) => {
  PlayerActions2["EnterFullscreen"] = "player.enterFullscreen";
  PlayerActions2["ExitFullscreen"] = "player.exitFullscreen";
  PlayerActions2["EnterPip"] = "player.enterPip";
  PlayerActions2["ExitPip"] = "player.exitPip";
  PlayerActions2["EnterAirPlay"] = "player.enterAirPlay";
  PlayerActions2["EnterTheaterMode"] = "player.enterTheaterMode";
  PlayerActions2["ExitTheaterMode"] = "player.exitTheaterMode";
  PlayerActions2["Play"] = "player.play";
  PlayerActions2["PlayFromStarttime"] = "player.playFromStarttime";
  PlayerActions2["Pause"] = "player.pause";
  PlayerActions2["TogglePlay"] = "player.togglePlay";
  PlayerActions2["ToggleSubtitles"] = "player.toggleSubtitles";
  PlayerActions2["Mute"] = "player.mute";
  PlayerActions2["Unmute"] = "player.unmute";
  PlayerActions2["ToggleMute"] = "player.toggleMute";
  PlayerActions2["SetPoster"] = "player.setPoster";
  PlayerActions2["SetVolume"] = "player.setVolume";
  PlayerActions2["SeekTo"] = "player.seekTo";
  PlayerActions2["SeekToLive"] = "player.seekToLive";
  PlayerActions2["SeekToRelativeTime"] = "player.seekToRelativeTime";
  PlayerActions2["SeekToPosition"] = "player.seekToPosition";
  PlayerActions2["Speak"] = "player.speak";
  PlayerActions2["StopPlayNextCountdown"] = "player.stopPlayNextCountdown";
  PlayerActions2["PlayNextEpisode"] = "player.playNextEpisode";
  PlayerActions2["SelectStream"] = "player.selectStream";
  PlayerActions2["SkipToPoint"] = "player.skipToPoint";
  PlayerActions2["ShowOverlayMenu"] = "player.showOverlayMenu";
  PlayerActions2["HideOverlayMenu"] = "player.hideOverlayMenu";
  PlayerActions2["ShowSettings"] = "player.showSettings";
  PlayerActions2["ShowChapters"] = "player.showChapters";
  PlayerActions2["SelectSubtitles"] = "player.selectSubtitles";
  PlayerActions2["ShowRecommendationsForProgram"] = "player.showRecommendationsForProgram";
  PlayerActions2["DismissRecommendationsForProgramCountdown"] = "player.dismissRecommendationsForProgramCountdown";
  return PlayerActions2;
})(PlayerActions || {});
export {
  PlayerActions
};
